import { render, staticRenderFns } from "./xxcj.vue?vue&type=template&id=0b69f534"
import script from "./xxcj.vue?vue&type=script&lang=js"
export * from "./xxcj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports